export const competitionsQueryKeys = {
  list: () => ['competitions', 'list'] as const,
};
